// The only module that reads the build environment. Vite exposes the REACT_APP_* variables on
// import.meta.env (`envPrefix` in vite.config.mts), where CRA used process.env.
// Vite replaces only the literal `import.meta.env` expression, so it must not be destructured.
// eslint-disable-next-line prefer-destructuring
const env = import.meta.env;

// The flag variables hold JSON (`true`, `false`); the parsed value is used for its truthiness only.
const parseJsonFlag = (value: string | undefined): unknown => (value ? JSON.parse(value) : false);

export default {
  isDevelopment: !env.PROD,
  isProduction: env.PROD,
  isStaging: parseJsonFlag(env.REACT_APP_IS_STAGING),
  debug: parseJsonFlag(env.REACT_APP_DEBUG),
  apiUrl: env.REACT_APP_API_URL,
  defaultLocale: env.REACT_APP_DEFAULT_LOCALE,
  dataProtectionUrl: env.REACT_APP_DATA_PROTECTION_URL || 'https://www.hyponoe.at/datenschutz',
  impressumUrl: env.REACT_APP_IMPRESSUM_URL || 'https://www.hyponoe.at/impressum',
  graphqlServerUrl: env.REACT_APP_GRAPHQL_SERVER_URL,
  dsn: env.REACT_APP_DSN,
  enuPartnerLink: env.REACT_APP_ENU_PARTNER_URL,
  applicationType: env.REACT_APP_APPLICATION_TYPE,
  // The path the app is served under (`base` in vite.config.mts) without the trailing slash,
  // the value CRA exposed as process.env.PUBLIC_URL.
  publicUrl: env.BASE_URL.replace(/\/$/, ''),
};
